import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideLucideIcons } from '@lucide/angular';

import { Icons } from '../icons/icons';

export function provideIcons(): EnvironmentProviders {
    return makeEnvironmentProviders([provideLucideIcons(...Icons)]);
}
